import { SVGIconProps } from './types/types';

const StepsChallenge = ({ width, height }: SVGIconProps) => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 80 80'
  >
    <defs>
      <circle id='a' cx='40' cy='40' r='40' />
      <path id='c' d='M.249 21.913l15.448 3.402L22.86 3.606 5.217.135z' />
      <path id='e' d='M.249 21.913l15.448 3.402L22.86 3.606 5.217.135z' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <use fill='#F4F4F7' href='#a' />
      <g mask='url(#b)'>
        <path
          fill='#DFDEDE'
          d='M37.526 32.748L22.81 29.37l6.283-34.278h20.933z'
        />
        <path
          fill='#6C6D6D'
          d='M23.654 28.817l13.388 3.074L47.967-.8 29.681-4.065l-6.027 32.882zm13.873 4.659a.756.756 0 0 1-.165-.02l-14.718-3.378a.727.727 0 0 1-.555-.839l6.283-34.278a.733.733 0 0 1 .85-.585l19.836 3.541a.723.723 0 0 1 .565.945L38.22 32.977a.732.732 0 0 1-.694.499z'
        />
        <path
          fill='#FEFEFE'
          d='M37.526 32.748l-15.448-3.402 4.968-21.779L44.69 11.04z'
        />
        <path
          fill='#6C6D6D'
          d='M22.954 28.794l14.084 3.102 6.698-20.303-16.133-3.175-4.649 20.376zm14.573 4.681a.742.742 0 0 1-.16-.017L21.92 30.056a.723.723 0 0 1-.555-.87l4.968-21.78a.733.733 0 0 1 .856-.552l17.642 3.472a.724.724 0 0 1 .553.94l-7.163 21.709c-.1.304-.384.5-.694.5z'
        />
        <path
          fill='#FEFEFE'
          d='M37.526 32.748l-15.448-3.402 4.968-21.779L44.69 11.04z'
        />
        <g>
          <g transform='translate(21.83 7.433)'>
            <mask id='d' fill='#fff'>
              <use href='#c' />
            </mask>
            <path
              fill='#7C53A5'
              d='M21.097 10.081l-17.2-3.31.277-1.428 17.201 3.31z'
              mask='url(#d)'
            />
          </g>
          <g transform='translate(21.83 7.433)'>
            <mask id='f' fill='#fff'>
              <use href='#e' />
            </mask>
            <path
              fill='#7C53A5'
              d='M19.892 13.238L3.423 9.951l.288-1.426 16.47 3.287z'
              mask='url(#f)'
            />
          </g>
        </g>
        <g>
          <path
            stroke='#6C6D6D'
            strokeLinejoin='round'
            strokeWidth='1.561'
            d='M37.526 32.748l-15.448-3.402 4.968-21.779L44.69 11.04z'
          />
          <path
            fill='#424547'
            d='M55.017 60.25s9.064 2.085 13.06-2.708c-3.226-4.261-54.84-23.197-57.555-16.965-1.453 4.066 3.018 6.275 9.63 8.665L55.017 60.25z'
            opacity='.332'
          />
        </g>
        <g>
          <path
            fill='#FEFEFE'
            d='M28.425 29.933c1.455.335 3.172.27 4.709.072 2.13-.275 3.953-1.56 5.046-3.397l.033-.054c.608-.994 2.062-1.044 2.763-.112a21.49 21.49 0 0 1 1.062 1.551s7.427 12.867 25.781 25.393l.023.014c.101.058.79.536.339 2.535l-.064.185s-4.182 1.847-17.27-4.068l-.077-.035c-12.93-5.1-35.855-15.56-35.855-15.56l.064-.186s1.444-4.066 4.142-6.99c.37-1.759 1.242-4.87 5.544-5.491'
          />
          <path
            fill='#DFDEDE'
            d='M14.917 36.444s-4.82 3.206-3.583 5.494c0 0 .787 2.185 8.97 5.417.491.194.992.353 1.503.487 2.947.77 14.057 3.747 23.82 7.273 11.512 3.582 20.553 5.558 22.491.993 0 0-4.258 1.81-17.347-4.104-12.93-5.1-35.854-15.56-35.854-15.56'
          />
          <path
            fill='#6C6D6D'
            d='M12.023 41.693c.003 0 1.051 2.024 8.551 4.986.445.175.908.325 1.42.46 3.142.822 14.152 3.779 23.883 7.293 8.88 2.762 17.386 4.916 20.55 2.65-2.449.072-7.363-.531-15.959-4.416-11.857-4.676-32.422-14-35.475-15.388-1.438 1.04-3.657 3.126-3.014 4.316a.686.686 0 0 1 .044.099m50.425 17.801c-4.08 0-9.865-1.452-17.04-3.685-9.704-3.504-20.66-6.446-23.788-7.264a13.804 13.804 0 0 1-1.586-.515c-7.743-3.058-9.13-5.242-9.364-5.785-1.445-2.78 3.292-6.041 3.84-6.406a.734.734 0 0 1 .712-.056c.23.104 23.055 10.511 35.819 15.545 12.495 5.646 16.76 4.122 16.8 4.106a.744.744 0 0 1 .796.17c.205.209.27.517.155.786-.927 2.183-3.095 3.104-6.344 3.104'
          />
          <path
            fill='#FEFEFE'
            d='M19.058 29.454s7.11 4.415 5.045 11.127c-1.788-.799-9.186-4.137-9.186-4.137.125-.495.785-3.105 4.141-6.99'
          />
          <path
            fill='#6C6D6D'
            d='M15.798 36.043c1.536.693 5.74 2.59 7.81 3.518.444-2.253-.16-4.463-1.805-6.581a13.949 13.949 0 0 0-2.616-2.548c-2.09 2.525-2.997 4.445-3.39 5.61m8.306 5.266a.738.738 0 0 1-.3-.064c-1.788-.8-9.189-4.138-9.189-4.138a.726.726 0 0 1-.407-.84c.536-2.111 2.061-4.699 4.296-7.285a.735.735 0 0 1 .943-.144c.077.048 1.906 1.196 3.487 3.217 2.14 2.737 2.787 5.76 1.87 8.74a.73.73 0 0 1-.7.514'
          />
          <path
            fill='#6C6D6D'
            d='M67.517 55.535c-1.158.237-5.768.645-16.369-4.146l-.108-.048C39.456 46.772 19.585 37.78 15.838 36.077c.445-1.102 1.76-4.07 3.822-6.304a.725.725 0 0 0 .178-.343c.442-2.105 1.354-4.322 4.73-4.889.042.14.064.392.046.573-.22 1.571.258 4.747 3.646 5.527 1.34.308 3.012.337 4.967.085 2.307-.298 4.342-1.664 5.582-3.747l.028-.047a.905.905 0 0 1 .742-.43c.32-.012.62.122.811.375.581.773 1.013 1.478 1.013 1.478.026.046 1.009 1.715 3.07 4.398l-2.547 2.071a.724.724 0 0 0-.103 1.024.731.731 0 0 0 1.03.102l2.52-2.05c.372.466.776.957 1.204 1.467l-2.671 2.171a.724.724 0 0 0-.103 1.023.73.73 0 0 0 1.03.103l2.69-2.187a89.7 89.7 0 0 0 1.255 1.411L46.28 39.92a.724.724 0 0 0-.103 1.023.731.731 0 0 0 1.03.103l2.56-2.082c4.154 4.44 9.953 9.777 17.636 15.021l.04.026c.094.102.257.543.074 1.525M20.03 23.658a1.336 1.336 0 0 1 .022-.717 1.364 1.364 0 0 1 1.703-.9c.348.106.634.34.805.66.14.262.184.554.139.84-1.02.388-1.79.935-2.377 1.545a16.384 16.384 0 0 0-.292-1.428m48.203 29.128c-17.984-12.274-25.487-25.028-25.57-25.17a21.84 21.84 0 0 0-1.101-1.61c-.48-.637-1.247-.999-2.053-.956a2.376 2.376 0 0 0-1.918 1.12l-.04.067c-1.01 1.697-2.655 2.807-4.511 3.046-1.784.23-3.28.21-4.45-.058-2.922-.673-2.544-3.78-2.523-3.935.02-.193.095-1.192-.433-1.79a1.28 1.28 0 0 0-.951-.437.714.714 0 0 0-.123.007 9.88 9.88 0 0 0-.386.065 2.805 2.805 0 0 0-1.992-2.484 2.825 2.825 0 0 0-2.154.206 2.792 2.792 0 0 0-1.375 1.658c-.15.484-.165 1-.042 1.5.005.016.423 1.63.405 2.92h.065c-.35.768-.525 1.492-.635 2.004-2.68 2.983-4.096 6.921-4.156 7.09a.039.039 0 0 0-.003.007l-.064.186a.725.725 0 0 0 .387.896c.23.104 23.09 10.527 35.858 15.562l.075.034c8.107 3.663 12.917 4.396 15.471 4.396 1.616 0 2.33-.294 2.4-.325a.728.728 0 0 0 .395-.43l.064-.185a.91.91 0 0 0 .022-.076c.541-2.405-.388-3.151-.662-3.308'
          />
          <path
            fill='#FEFEFE'
            d='M44.094 14.095l-18.082-3.48a1.797 1.797 0 0 1-1.43-2.106l.042-.22a1.807 1.807 0 0 1 2.119-1.422l18.081 3.48a1.797 1.797 0 0 1 1.431 2.106l-.043.22a1.807 1.807 0 0 1-2.118 1.422'
          />
          <path
            fill='#6C6D6D'
            d='M44.233 13.381a1.071 1.071 0 0 0 1.26-.846l.044-.22a1.068 1.068 0 0 0-.852-1.254l-18.081-3.48a1.08 1.08 0 0 0-1.261.846l-.043.22a1.073 1.073 0 0 0 .852 1.254l18.08 3.48zm.21 1.475c-.162 0-.325-.015-.488-.047l-18.082-3.48a2.526 2.526 0 0 1-2.01-2.958l.043-.22c.129-.662.51-1.234 1.072-1.612a2.534 2.534 0 0 1 1.904-.386l18.081 3.48a2.525 2.525 0 0 1 2.01 2.958l-.042.22a2.507 2.507 0 0 1-1.072 1.612 2.533 2.533 0 0 1-1.416.433z'
          />
        </g>
      </g>
    </g>
  </svg>
);

export default StepsChallenge;
